import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import type { UseFiltersPayload } from '@domain-group/react-hooks'

import CreateAdminInvoiceModal from '@modals/CreateAdminInvoiceModal'
import InvoiceIntegrationSettingsModal from '@modals/InvoiceIntegrationSettingsModal'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { InvoiceModel } from '@models/types'

import PageContent from './components/PageContent'

export type PageContextPayload = UseFiltersPayload & {
  callbacks: {
    showCreateAdminInvoiceModal: () => void,
    showInvoiceIntegrationSettingsModal: () => void,
  },
}

const defaultState = {
  showCreateAdminInvoiceModal: false,
  showInvoiceIntegrationSettingsModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateAdminInvoiceModal: {
      closeModal: () => setState({ showCreateAdminInvoiceModal: false }),
      createInvoice: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    InvoiceIntegrationSettingsModal: {
      closeModal: () => setState({ showInvoiceIntegrationSettingsModal: false }),
      updateIntegration: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateAdminInvoiceModal,
    showInvoiceIntegrationSettingsModal,
  } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateAdminInvoiceModal: (payload: { invoice: InvoiceModel }) => {
        setModalData('CreateAdminInvoiceModal', payload)
        setState({ showCreateAdminInvoiceModal: true })
      },
      showInvoiceIntegrationSettingsModal: (payload: { invoice: InvoiceModel }) => {
        setModalData('InvoiceIntegrationSettingsModal', payload)
        setState({ showInvoiceIntegrationSettingsModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateAdminInvoiceModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateAdminInvoiceModal', setState)}
          showModal={showCreateAdminInvoiceModal}
        />

        <InvoiceIntegrationSettingsModal
          // @ts-expect-error TS2322
          callbacks={callbacks('InvoiceIntegrationSettingsModal', setState)}
          showModal={showInvoiceIntegrationSettingsModal}
        />
      </ModalContext.Provider>

    </PageContext.Provider>
  )
}

export default List
